module.exports = __webpack_public_path__ + "img/ellipse-sucess.dd0f3685.svg";